import { ApiServiceBase } from '../../base/api-service-base';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

import { AuthService } from 'src/app/core/authentication/auth.service';
import { SeatPropertyGroupReferenceModel } from '../../models/reference-model/reference-general-model';

@Injectable({
  providedIn: 'root'
})
export class SeatPropertyGroupReferenceService extends ApiServiceBase {
  private readonly REFERENCE_PATH = "/system/seatpropertygroupreferences"
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) {
    super(httpClient, authService);
  }

  public getAll(): Observable<SeatPropertyGroupReferenceModel[]> {
    return this.httpGet<any>(this.REFERENCE_PATH, null)
      .pipe(
        map(response => {
          return response.body;
        })
      );
  }
}